import { createFromIconfontCN } from '@ant-design/icons';

export const IconFontUrl = '//at.alicdn.com/t/c/font_3312032_azx55pu8lk.js';
export const IconFont = createFromIconfontCN({
  scriptUrl: IconFontUrl,
});
